var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBackModal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "22px",
    viewBox: "0 0 13 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBackModal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.20045977,10.7545447 L12.1602547,2.71109755 C12.3794285,2.49015447 12.5,2.19474792 12.5,1.87976418 C12.5,1.56460561 12.3794285,1.26937389 12.1602547,1.04808126 L11.4627737,0.34365031 C11.2439459,0.122008125 10.951426,0 10.6397045,0 C10.3279831,0 10.0358091,0.122008125 9.8168084,0.34365031 L0.339403971,9.92006506 C0.119538247,10.1420569 -0.000860265805,10.438687 4.63419458e-06,10.7540204 C-0.000860265805,11.0707521 0.119365222,11.3670326 0.339403971,11.5891991 L9.80798604,21.1563497 C10.0269869,21.3779919 10.3191608,21.5 10.6310553,21.5 C10.9427767,21.5 11.2349507,21.3779919 11.4541244,21.1563497 L12.1514325,20.4519187 C12.6051757,19.9934269 12.6051757,19.2470448 12.1514325,18.7887277 L4.20045977,10.7545447 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Direct-Messages",
    transform: "translate(-448.000000, -176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBackModal",
    transform: "translate(433.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/PictureArrow",
    transform: "translate(21.500000, 25.000000) scale(-1, 1) translate(-21.500000, -25.000000) translate(15.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBackModal"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#646464",
    fillRule: "nonzero",
    transform: "translate(6.250000, 10.750000) scale(-1, 1) translate(-6.250000, -10.750000) ",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackModal);
export default __webpack_public_path__ + "static/media/icBackModal.44dcb1971da0f6d8cd197335befacaf2.svg";
export { ForwardRef as ReactComponent };